<div style="max-width: 600px; margin: auto;">
    <h1>Your Data Export</h1>
    
    <p>Good news! Your data export is ready to be downloaded. This link will expire in 24 hours.</p>
    <p>Click the button below to download an archive of your data, which will include the following:</p>
    <ul>
        <li>Account information</li>
        <li>How we got your data</li>
        <li>How we process your data</li>
        <li>What government agencies have purchased your data (including ICE)</li>
        <li>Which advertisiers have purchased your data</li>
        <li>Which advertisiers have stolen your data</li>
        <li>How you can delete your data</li>
    </ul>
    <p>Enter your Discord Username below to verify your identity.</p>
    <mat-form-field style="width: 100%;">
        <mat-label>Enter your Discord Username</mat-label>
        <input matInput [(ngModel)]="username"/>
    </mat-form-field>

    <app-fake-captcha (success)="onCaptchaSuccess($event)"></app-fake-captcha><br><br>

    
    
    <button mat-flat-button [disabled]="!downloadEnabled" (click)="onDownload()">Download your data now </button>

</div>
